/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Share_ViewsInputs */

const en_share_views = /** @type {(inputs: Share_ViewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} views`)
};

const de_share_views = /** @type {(inputs: Share_ViewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Aufrufe`)
};

/**
* | output |
* | --- |
* | "{count} views" |
*
* @param {Share_ViewsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const share_views = /** @type {((inputs: Share_ViewsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_ViewsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_share_views(inputs)
	return en_share_views(inputs)
});